import { lazy, Suspense } from 'react';
import { Route, Routes, type NavigateFunction } from 'react-router';

import { LoadingFallback } from '../components/LoadingFallback';
import { makeSharedRoutes, AdaptiveOAuthFlowRoutes } from './SharedRoutes';

const ErrorScreen = lazy(() => import('../pages/ErrorScreen'));
const HomePage = lazy(() =>
  import('../pages/HomePage').then((module) => ({ default: module.HomePage })),
);
const CEFRLevelStep = lazy(() => import('../pages/result-steps/CEFRLevelStep'));
const InstallAppStep = lazy(() => import('../pages/result-steps/InstallAppStep'));
const NumberOfWordsStep = lazy(() => import('../pages/result-steps/NumberOfWordsStep'));
const SharedResultsScreen = lazy(() => import('../pages/SharedResultsScreen'));
const VocabComparisonStep = lazy(() => import('../pages/result-steps/VocabComparisonStep'));
const WordsYouDidntKnowStep = lazy(() => import('../pages/result-steps/WordsYouDidntKnowStep'));

const sharedRoutes = makeSharedRoutes('/vocab');

const RESULT_PREFIX = '/result/';

export const ROUTES = {
  HOME: '/',

  ...sharedRoutes,

  RESULT_NUM_WORDS: '/result/num-words/',
  RESULT_CEFR_LEVEL: '/result/cefr-level/',
  RESULT_VOCAB_COMPARISON: '/result/vocab-comparison/',
  RESULT_WORDS_UNKNOWN: '/result/words-unknown/',
  RESULT_INSTALL_APP: '/result/install-app/',
  RESULT_PREFIX,
  buildResultPath: (shortcode: string | null | undefined): string => `${RESULT_PREFIX}${shortcode}`,
  navigateToResults: (navigate: NavigateFunction) => {
    void navigate('/result/num-words/');
  },

  ERROR: '/error',
} as const;

const ROUTE_PATTERNS = {
  RESULT_SHORTCODE: '/result/:shortcode',
} as const;

export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path={ROUTES.HOME} element={<HomePage nextPath={ROUTES.TEST_ROOT} />} />
        <Route path={'/vocab/*'} element={<AdaptiveOAuthFlowRoutes />} />
        <Route
          path={ROUTES.RESULT_NUM_WORDS}
          element={<NumberOfWordsStep nextPath={ROUTES.RESULT_CEFR_LEVEL} />}
        />
        <Route
          path={ROUTES.RESULT_CEFR_LEVEL}
          element={<CEFRLevelStep nextPath={ROUTES.RESULT_VOCAB_COMPARISON} />}
        />
        <Route path={ROUTES.RESULT_VOCAB_COMPARISON} element={<VocabComparisonStep />} />
        <Route
          path={ROUTES.RESULT_WORDS_UNKNOWN}
          element={<WordsYouDidntKnowStep nextPath={ROUTES.RESULT_INSTALL_APP} />}
        />
        <Route path={ROUTES.RESULT_INSTALL_APP} element={<InstallAppStep />} />
        <Route path={ROUTE_PATTERNS.RESULT_SHORTCODE} element={<SharedResultsScreen />} />
        <Route path="*" element={<ErrorScreen />} />
      </Routes>
    </Suspense>
  );
}
